import { LegalShell } from "@/components/LegalShell";

export default function DistanceSales() {
  return (
    <LegalShell title="Mesafeli Satış Sözleşmesi" updated="Haziran 2026">
      <h2>1. Taraflar</h2>
      <p>
        İşbu Mesafeli Satış Sözleşmesi; bir tarafta hizmeti sunan <strong>Ustayla.com</strong> (“Satıcı/Platform”)
        ile diğer tarafta cüzdanına bakiye yükleyen/dijital hizmet satın alan <strong>Kullanıcı</strong> (“Alıcı”)
        arasında, aşağıdaki şartlarda elektronik ortamda kurulmuştur.
      </p>

      <h2>2. Sözleşmenin Konusu</h2>
      <p>
        Sözleşmenin konusu, Alıcı’nın Platform üzerinden elektronik olarak sipariş verdiği <strong>dijital hizmet
        bakiyesi</strong> ve buna bağlı dijital hizmetlerin (iletişim bilgisi açma, ilan öne çıkarma vb.)
        satışı ve ifasıdır.
      </p>

      <h2>3. Ürün/Hizmet ve Ödeme Bilgileri</h2>
      <ul>
        <li>Satın alınan hizmetin tutarı, ödeme adımında Alıcı’ya açıkça gösterilir.</li>
        <li>Ödemeler, güvenli ödeme altyapısı <strong>iyzico</strong> üzerinden Visa / MasterCard kartları ile 256-bit SSL şifreleme kullanılarak tahsil edilir.</li>
        <li>Tüm vergiler tutara dahildir.</li>
      </ul>

      <h2>4. İfa (Teslimat)</h2>
      <p>
        Dijital hizmet, ödeme onayının ardından <strong>anında</strong> Alıcı’nın hesabına tanımlanır. Fiziksel
        teslimat veya kargo süreci bulunmamaktadır.
      </p>

      <h2>5. Cayma Hakkı</h2>
      <p>
        Anında ifa edilen dijital içerik/hizmetlerde, ifaya başlanmasıyla cayma hakkı sona erer. Kullanılmamış
        bakiyelere ilişkin iade koşulları <strong>Teslimat ve İade Şartları</strong> sayfasında düzenlenmiştir ve
        işbu sözleşmenin ayrılmaz parçasıdır.
      </p>

      <h2>6. Platformun Rolü</h2>
      <p>
        Ustayla, işveren ile usta arasındaki hizmet bedelini tahsil etmez; taraflar arasındaki gerçek hizmet
        ödemesi taraflar arasındadır. Platform yalnızca dijital hizmet bakiyesi ve tanıtım hizmetleri satar.
      </p>

      <h2>7. Uyuşmazlık Çözümü</h2>
      <p>
        İşbu sözleşmeden doğabilecek uyuşmazlıklarda, ilgili mevzuat çerçevesinde Tüketici Hakem Heyetleri ve
        Tüketici Mahkemeleri yetkilidir. İletişim: <strong>info@ustayla.com</strong>
      </p>
    </LegalShell>
  );
}
